export default __webpack_public_path__ + "static/media/confirmacao-de-publicacao.d84ba9f8.svg";